<div id="tooltip" #tooltip>
  <p>{{currentPosition}}</p>
  <p>{{currentCount}}</p>
</div>
<svg></svg>
